import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgToggleModule } from '@nth-cloud/ng-toggle';

import { FontawesomeModule } from '../fontawesome/fontawesome.module';

import { DebounceDirective } from './debounce.directive';
import { KeysPipe } from './keys.pipe';
import { ListSortItemComponent } from './list-sort-item/list-sort-item.component';
import { ListSortDirective } from './list-sort.directive';
import { MilesPipe } from './miles.pipe';
import { ToastComponent } from './toast/toast.component';

@NgModule({
  declarations: [
    DebounceDirective,
    KeysPipe,
    ListSortItemComponent,
    ListSortDirective,
    MilesPipe,
    ToastComponent
  ],
  imports: [
    CommonModule,
    FontawesomeModule,
    NgToggleModule
  ],
  exports: [
    NgToggleModule,
    DebounceDirective,
    KeysPipe,
    ListSortItemComponent,
    ListSortDirective,
    MilesPipe,
    ToastComponent
  ]
})
export class SharedModule { }
